// extensions/CustomTableHeader.ts
import { TableHeader } from '@tiptap/extension-table';

export const CustomTableHeader = TableHeader.extend({
  content: 'block+',

  addAttributes() {
    return {
      ...this.parent?.(),
      role: {
        default: null,
        parseHTML: el => el.getAttribute('data-role'),
        renderHTML: a => (a.role ? { 'data-role': a.role } : {}),
      },
      class: {
        default: null,
        parseHTML: el => el.getAttribute('class'),
        // 'locked' used to be stored here; locks are now per-user decorations, so drop stale copies
        renderHTML: a => {
          const cls = a.class?.replace(/\blocked\b/g, '').replace(/\s+/g, ' ').trim();
          return cls ? { 'class': cls } : {};
        },
      },
    };
  },
});
